import { forwardRef } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';
import { SupportedGridSizes } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';

import {
  LocationTypeahead,
  LocationTypeaheadProps,
} from 'src/common/LocationTypeahead/LocationTypeahead';

import type { HelperText } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldLocationTypeaheadProps = {
  label?: React.ReactNode;
  helperText?: HelperText;
  colSpan?: SupportedGridSizes;
  inline?: boolean;
} & LocationTypeaheadProps;

export const CoreFormFieldLocationTypeahead = forwardRef(
  function _CoreFormFieldLocationTypeahead(
    {
      colSpan,
      error,
      helperText,
      inline,
      label,
      inputProps,

      ...rest
    }: CoreFormFieldLocationTypeaheadProps,
    ref: React.Ref<HTMLInputElement>
  ) {
    return (
      <FormFieldContainer colSpan={colSpan}>
        <DefaultFormFieldLayout
          label={label}
          error={error}
          inputId={inputProps?.id}
          inline={inline}
          helperText={helperText}
        >
          <LocationTypeahead
            {...rest}
            inputProps={inputProps}
            error={error}
            ref={ref}
          />
        </DefaultFormFieldLayout>
      </FormFieldContainer>
    );
  }
);
